import axios, { AxiosPromise } from 'axios'
import { apiUrl, getAxiosRequestConfigWithHeaders } from '../misc/Utils'
import {
  FeedbackType,
  GetStartedStatusResponse,
} from '../definitions/api.types'

export class AppService {
  getAppInfo() {
    return axios.get(
      apiUrl('/api/v1/app/info'),
      getAxiosRequestConfigWithHeaders()
    )
  }

  getStatus() {
    return axios.get(
      apiUrl('/api/v1/status/'),
      getAxiosRequestConfigWithHeaders()
    )
  }

  getStatusSubscription() {
    return axios.get<{ subscribed: boolean }>(
      apiUrl('/api/v1/status/subscription'),
      getAxiosRequestConfigWithHeaders()
    )
  }

  subscribeStatusPage() {
    return axios.post<{ subscribed: boolean }>(
      apiUrl('/api/v1/status/subscription/subscribe'),
      {},
      getAxiosRequestConfigWithHeaders()
    )
  }

  unsubscribeStatusPage() {
    return axios.post<{ subscribed: boolean }>(
      apiUrl('/api/v1/status/subscription/unsubscribe'),
      {},
      getAxiosRequestConfigWithHeaders()
    )
  }

  getGetStartedStatus(): AxiosPromise<GetStartedStatusResponse> {
    return axios.get(
      apiUrl('/api/v1/app/get-started'),
      getAxiosRequestConfigWithHeaders()
    )
  }

  updateAnalytics(enabled: boolean) {
    return axios.put(
      apiUrl('/api/v1/app/analytics'),
      { enabled },
      getAxiosRequestConfigWithHeaders()
    )
  }

  resendVerificationEmail() {
    return axios.post(
      apiUrl('/api/v1/user/resend-verification-email'),
      {},
      getAxiosRequestConfigWithHeaders()
    )
  }

  submitFeedback(data: {
    type: FeedbackType
    subject: string
    description: string
    debugInfo: any
  }) {
    return axios.post(
      apiUrl('/api/v1/app/feedback'),
      data,
      getAxiosRequestConfigWithHeaders()
    )
  }
}
